module.exports = __webpack_public_path__ + "static/media/pw-rating-icon.f0c157b4.svg";